import React from "react";
import Chat from "./Chat";
import io from "socket.io-client";
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserConsInfo } from "../../../Redux/Actions/user/userAll";
import { useParams } from "react-router-dom";
import ConsNotes from "./ConsNotes";
import VideoCall from "./VideoCall";
import jwtDecode from "jwt-decode";
import JoinCallLayout from "../../Layout/JoinCallLayout";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Rating } from "react-simple-star-rating";
export default function JoinCall() {
  const BASE_URL = process.env.REACT_APP_HOST_NAME;
  const [socket, setSocket] = useState();
  const dispatch = useDispatch();
  const socketRef = useRef();
  const { id } = useParams();
  const userConsInfo = useSelector((state) => state.consultaions.consInfo);
  const [me, setMe] = useState("");
  const [onlineUsers, setOnlineUsers] = useState();

  useEffect(() => {
    socketRef.current = io.connect(BASE_URL);
    socketRef.current.emit(
      "video-user-add",
      jwtDecode(sessionStorage.getItem("token")).id
    );
    socketRef.current.on("me", (myId) => {
      setMe(myId);
    });
    setSocket(socketRef.current);
    dispatch(getUserConsInfo(id));
    return () => {
      socketRef.current.disconnect();
    };
  }, []);

  useEffect(() => {
    socketRef.current.on("video-users", (users) => {
      setOnlineUsers(users);
    });
  }, [socketRef.current]);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <JoinCallLayout>
      <div className="col-lg-10">
        <div className="desc_area pb-0">
          <div className="row">
            <div className="col-lg-7">
              {onlineUsers && socket && userConsInfo && me ? (
                <VideoCall
                  me={me}
                  consInfo={userConsInfo?.cons}
                  socket={socketRef.current}
                  onlineUsers={onlineUsers}
                />
              ) : (
                console.log(onlineUsers, socket, userConsInfo, me)
              )}
              {userConsInfo && socket ? (
                <Chat socket={socket} userConsInfo={userConsInfo} />
              ) : null}
            </div>
            {userConsInfo && socket ? (
              <ConsNotes socket={socket} userConsInfo={userConsInfo} />
            ) : null}
          </div>
        </div>
      </div>
      <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button>
      <Modal show={show} onHide={handleClose} className="rating-main-popup">
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="rating-sec">
            <div className="row">
              <div className="col-lg-12">
                <h3>Rate us the quality of video call service</h3>
              </div>
              <div className="col-lg-12 d-flex justify-content-center">
                <Rating />
              </div>
              <div className="col-lg-12 mt-4">
                <h5>Review(Optional)</h5>
                <textarea rows={3} placeholder="" className="w-100"></textarea>
              </div>
              {/* <div className="col-lg-12 d-flex justify-content-end">
                <button onClick={handleClose} className="review-later"></button>
              </div> */}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button variant="primary" onClick={handleClose}>
            Review Later
          </Button>
        </Modal.Footer>
      </Modal>
    </JoinCallLayout>
  );
}
